import type { ThreadMessage } from "@rakazo/contracts";

/** The latest bot reply and the user text before it, for "Send again". Null when the thread does not end in a bot reply. */
export function latestResendTarget(
  messages: readonly ThreadMessage[],
): { botMessageId: string; text: string } | null {
  let botMessageId: string | null = null;
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index]!;
    if (message.id.startsWith("progress:")) return null;
    if (botMessageId === null) {
      if (message.role !== "bot") return null;
      if (!message.blocks.some((block) => block.kind === "text")) return null;
      botMessageId = message.id;
      continue;
    }
    if (message.role !== "user") continue;
    const text = message.blocks
      .flatMap((block) => (block.kind === "text" ? [block.text] : []))
      .join("\n")
      .trim();
    return text ? { botMessageId, text } : null;
  }
  return null;
}
